import classNames from 'classnames';

import { useDebitCardActions } from 'hooks/useDebitCardActions';
import { numToDollars } from 'util/index';

import Button from '@mui/material/Button';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        button: {
          display: 'flex',
          alignItems: 'center',
          flex: 'none',
          flexGrow: 0,
          gap: '8px',
          borderRadius: '20px',
          boxSizing: 'border-box',
          fontWeight: 800,
          height: '40px',
          order: 0,
          padding: '0px 32px',
          textTransform: 'none'
        },
        buttonCancel: {
          border: '1px solid #7378E8',
          color: '#7378E8'
        },
        buttonConfirm: {
          backgroundColor: '#7378E8',
          color: '#FFFFFF'
        },
        buttonContainer: {
          marginTop: '42px',
          display: 'flex',
          justifyContent: 'space-between'
        },
        cardStyle: {
          margin: '0px !important'
        },
        transferCardContainer: {
          display: 'flex',
          flexDirection: 'column',
        },
        title: {
          color: '#7378E8',
          fontWeight: 800,
          marginBottom: '16px',
          textAlign: 'left'
        },
        label: {
          margin: '0',
          color: '#1F2152',
          fontSize: '16px',
          fontWeight: 400,
          textAlign: 'left'
        }
    })
);

type CardTransferConfirmationProps = {
    amount: number;
    onClose: () => void;
    onConfirm: () => void;
};

const CardTransferConfirmation: React.FC<CardTransferConfirmationProps> = ({
    amount,
    onClose,
    onConfirm
}) => {
    const classes = useStyles();

    const { debitInfo } = useDebitCardActions();

    const { card_last4 } = debitInfo || {
        card_last4: null,
    };

    const cancelButtonClass = classNames(classes.button, classes.buttonCancel);
    const confirmButtonClass = classNames(
        classes.button,
        classes.buttonConfirm
    );

    const formattedAmount = numToDollars(amount);

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <div className={classes.transferCardContainer}>
            <h2 className={classes.title}>
                Transfer {formattedAmount} to Card
                {card_last4 && ` Ending in ${card_last4}`}
            </h2>
            <p className={classes.label}> 
            Are you sure you want to transfer {formattedAmount} from membership balance to this debit card?
            </p>
            <div className={classes.buttonContainer}>
                <Button className={cancelButtonClass} onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    className={confirmButtonClass}
                    onClick={handleConfirm}
                >
                    Yes, Transfer
                </Button>
            </div>
        </div>
    );
};

export default CardTransferConfirmation;
